export enum ERequestActions {
    EDIT_IN_BUILDER = 'EDIT_IN_BUILDER',
    CANCEL = 'CANCEL',
    DELETE_FILES = 'DELETE_FILES',
}
